module.exports = __webpack_public_path__ + "static/website-icon-82cab62701c303f56f2e5b8de2f1912f.png";